/*
 * @Author: your name
 * @Date: 2022-01-28 15:32:26
 * @LastEditTime: 2024-11-21 21:08:32
 * @LastEditors: bobo 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\filterField\BsyFilterText\index.jsx
 */

import React from 'react'
import { BsyUtils } from '../../../utils/Utils';

import BsySelectList from '../../BsySelectList';
import BsySelectListCheckBox from '../../BsySelectListCheckBox';
import BsyUserCheck from '../../BsyUserCheck';
import BsyUserCheckBox from '../../BsyUserCheckBox';

import BsyFilterBase from '../BsyFilterBase';

import './index.css'
import { BsyConfig } from '../../../global/BsyConfig';

export class BsyFilterUser extends BsyFilterBase {
    constructor(props) {
        super({
            minRow: 10,
            onStopEdit: null,
            customItem: {
                nickname: React.language("unfilled"),
                _id: "hasEmpty"
            },
            displayType: {
                list: "checklist",
                box: "usercheck"
            },
            ...props
        })

        this.dashText = null;
    }

    doFilterRely = (t, rel,widgetFilter) => {
        this.filterRely = t;
        this.rel = rel;
        this.dashText && this.dashText.doFilterRely && this.dashText.doFilterRely(t, rel,widgetFilter)
    }

    changeMethod = (t, a) => {
        let e = this
            , i = this.options
        if (t !== e.method) {
            e.method = t
            this.value = {};
            this.userCheckKey = 'userCheckKey' + new Date().getTime();
            this.setState({}, () => {
                BsyUtils.applyFunc(e, i.onStopEdit, [{
                    value: null,
                    method: e.method,
                    valueMode: e.valueMode
                }, i], !1)
                BsyUtils.applyFunc(e, i.onMethodChange, [e.method], !1)
            })
        }

    }

    _getAvailableMethods = () => {
        let method = [BsyConfig().CONST.FILTER_METHOD.EQ,
        BsyConfig().CONST.FILTER_METHOD.NE,
        BsyConfig().CONST.FILTER_METHOD.IN,
        BsyConfig().CONST.FILTER_METHOD.NIN,
        BsyConfig().CONST.FILTER_METHOD.EP,
        BsyConfig().CONST.FILTER_METHOD.NEP];
        if (this.options.type === "flowcreator_filter") {
            method = [
                BsyConfig().CONST.FILTER_METHOD.EQ,
                BsyConfig().CONST.FILTER_METHOD.NE,
                BsyConfig().CONST.FILTER_METHOD.IN,
                BsyConfig().CONST.FILTER_METHOD.NIN
            ]
        }
        return method
    }


    getValue = () => {

        if (this.dashText) {
            let e = this.dashText.getValue()

            switch (this.method) {
                case BsyConfig().CONST.FILTER_METHOD.EQ:
                case BsyConfig().CONST.FILTER_METHOD.NE:
                    return {
                        value: e
                    };
                case BsyConfig().CONST.FILTER_METHOD.IN:
                case BsyConfig().CONST.FILTER_METHOD.NIN:

                    if ("checklist" === this._getCompType()) {
                        let a = !1
                            , n = [];
                        BsyUtils.forEach(e, function (e, i) {
                            i !== t.customItem.value ? n.push(i) : a = !0
                        })
                        return {
                            hasEmpty: a,
                            items: n
                        }
                    }
                    if (BsyUtils.isObjectEmpty(e))
                        return { items: [], hasEmpty: false };
                    let e1 = [].concat(e)
                        , t = !1
                        , i = e.indexOf(BsyConfig().CONST.PARAMETER.EMPTY);
                    if (i > -1) {
                        t = !0
                        e1.splice(i, 1)
                    }
                    return {
                        hasEmpty: t,
                        items: e1
                    }
                default:
                    return null
            }
        }
        return null
    }

    getContext = (e) => {
        this.dashText = e;
        if (this.filterRely) {
            this.doFilterRely(this.filterRely, this.rel)
        }
    }


    renderCont = () => {
        let { appId, entryId } = this.options;
        let e = this
        let i = this.options;
        let val = this.getMiddleValue() || {};
        let c = this._getAsyncConfig();
        if (BsyUtils.isObjectEmpty(c)) {
            this.dashText = null;
            return <span className='error-tip'>{React.language("field.deleted.tip1")}</span>;
        }
        if (!c.data.hasOwnProperty('hasCurrentUser')) {
            c.data.hasCurrentUser = true;
        }
        switch (e.method) {
            case BsyConfig().CONST.FILTER_METHOD.EQ:
            case BsyConfig().CONST.FILTER_METHOD.NE:
                if (i.height > i.minRow) {
                    return <BsySelectList
                        hasLimit={!0}
                        theme={this.props.theme}
                        allowBlank={true}
                        value={val ? val.value : null}
                        asyncResultKey={i.asyncResultKey || "items"}
                        textField={'nickname'}
                        valueField={"_id"}
                        onBeforeAsync={i.onBeforeAsync}
                        onStopEdit={e1 => {
                            e.value = e.getValue()
                            BsyUtils.applyFunc(e, i.onStopEdit, [{
                                value: e.getValue(),
                                valueMode: e.valueMode,
                                method: e.method,
                            }, i], !1)
                        }}
                        getContext={this.getContext}
                        onCustomItem={(e) => {
                            var title = BsyUtils._getSeachUserDeptList(e, null, { appId: appId || window.FX.STATIC.APPID, entryId: entryId || window.FX.STATIC.ENTRYID })
                            if (!title) {
                                return <span
                                    style={{
                                        overflow: 'unset',
                                        textOverflow: 'unset',
                                        whiteSpace: 'nowrap',
                                    }}
                                    title={e.nickname + ' ' + title} >
                                    {e.nickname}</span>
                            }
                            return <>
                                <span
                                    style={{
                                        overflow: 'unset',
                                        textOverflow: 'unset',
                                        whiteSpace: 'nowrap'
                                    }}
                                    title={e.nickname + ' ' + title} >
                                    {e.nickname}</span>
                                <span
                                    style={{
                                        overflow: 'unset',
                                        textOverflow: 'unset',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px',
                                        color: '#4D609F'
                                    }}
                                    title={e.nickname + ' ' + title} >
                                    {title}</span>
                            </>
                        }}
                        async={c}
                    ></BsySelectList>
                } else {
                    return <BsyUserCheck
                        hasLimit={!0}
                        theme={this.props.theme}
                        allowBlank={true}
                        height={'34px'}
                        asyncResultKey={i.asyncResultKey || "items"}
                        value={val ? val.value : null}
                        emptySelectText={this.options.type === "flowcreator_filter" ? React.language('widget.user.anonymous') : React.language("unfilled")}
                        // hasSelectEmpty={this.options.type === "flowcreator_filter" ? true : false}
                        hasSelectEmpty={false}
                        textField={'nickname'}
                        valueField={"_id"}
                        onCustomItem={(e) => {
                            var title = BsyUtils._getSeachUserDeptList(e, null, { appId: appId || window.FX.STATIC.APPID, entryId: entryId || window.FX.STATIC.ENTRYID })
                            if (!title) {
                                return <span
                                    style={{
                                        overflow: 'unset',
                                        textOverflow: 'unset',
                                        whiteSpace: 'nowrap'

                                    }}
                                    title={e.nickname + ' ' + title} >
                                    {e.nickname}</span>
                            }
                            return <>
                                <span
                                    style={{
                                        overflow: 'unset',
                                        textOverflow: 'unset',
                                        whiteSpace: 'nowrap'

                                    }}
                                    title={e.nickname + ' ' + title} >
                                    {e.nickname}</span>
                                <span
                                    style={{
                                        overflow: 'unset',
                                        textOverflow: 'unset',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px',
                                        color: '#4D609F'

                                    }}
                                    title={e.nickname + ' ' + title} >
                                    {title}</span>
                            </>
                        }}
                        onAfterAsync={(e1) => {

                            if (e.options.type === "flowcreator_filter") {
                                if (e.method === BsyConfig().CONST.FILTER_METHOD.NIN)
                                    return e1;
                                return [{
                                    nickname: React.language("widget.user.anonymous"),
                                    _id: "anonymous",
                                }, ...e1]
                            }

                            return e1;
                        }}
                        onStopEdit={e1 => {
                            e.value = e.getValue()
                            BsyUtils.applyFunc(e, i.onStopEdit, [{
                                value: e.getValue(),
                                valueMode: e.valueMode,
                                method: e.method,
                            }, i], !1)
                        }}
                        getContext={this.getContext}
                        async={c}
                    />
                }


            case BsyConfig().CONST.FILTER_METHOD.IN:
            case BsyConfig().CONST.FILTER_METHOD.NIN:
                // this._createComboCheck();
                let vals = [];
                if (val.hasEmpty) {
                    vals.push(BsyConfig().CONST.PARAMETER.EMPTY)
                }
                if (val.hasCurrentUser) {
                    vals.push(BsyConfig().USER_ID.CurrentUser)
                }
                if (val.items)
                    vals = vals.concat(val.items);
                if (i.height > i.minRow) {
                    return <BsySelectListCheckBox

                        theme={this.props.theme}
                        getContext={this.getContext}
                        asyncResultKey={i.asyncResultKey || "items"}
                        emptySelectText={this.options.type === "flowcreator_filter" ? React.language('widget.user.anonymous') : React.language("unfilled")}
                        hasSelectEmpty={this.options.type === "flowcreator_filter" ? false : true}
                        hasLimit={!0}
                        onBeforeAsync={i.onBeforeAsync}
                        value={vals}
                        textField={'nickname'}
                        valueField={"_id"}
                        onCustomItem={(e) => {
                            var title = BsyUtils._getSeachUserDeptList(e, null, { appId: appId || window.FX.STATIC.APPID, entryId: entryId || window.FX.STATIC.ENTRYID })
                            if (!title) {
                                return <span
                                    style={{
                                        overflow: 'unset',
                                        textOverflow: 'unset',
                                        whiteSpace: 'nowrap'

                                    }}
                                    title={e.nickname + ' ' + title} >
                                    {e.nickname}</span>
                            }
                            return <>
                                <span
                                    style={{
                                        overflow: 'unset',
                                        textOverflow: 'unset',
                                        whiteSpace: 'nowrap'

                                    }}
                                    title={e.nickname + ' ' + title} >
                                    {e.nickname}</span>
                                <span
                                    style={{
                                        overflow: 'unset',
                                        textOverflow: 'unset',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px',
                                        color: '#4D609F'

                                    }}
                                    title={e.nickname + ' ' + title} >
                                    {title}</span>
                            </>
                        }}
                        onStopEdit={e1 => {
                            e.value = e.getValue()
                            BsyUtils.applyFunc(e, i.onStopEdit, [{
                                value: e.getValue(),
                                valueMode: e.valueMode,
                                method: e.method,
                            }, i], !1)
                        }}
                        async={c}
                    />
                } else {
                    return <BsyUserCheckBox
                        key={this.userCheckKey}
                        theme={this.props.theme}
                        getContext={this.getContext}
                        hasLimit={!0}
                        height={'34px'}
                        value={vals}
                        emptySelectText={this.options.type === "flowcreator_filter" ? React.language('widget.user.anonymous') : React.language("unfilled")}
                        hasSelectEmpty={this.options.type === "flowcreator_filter" ? false : true}
                        asyncResultKey={i.asyncResultKey || "items"}
                        textField={'nickname'}
                        valueField={"_id"}
                        onBeforeAsync={i.onBeforeAsync}
                        onCustomItem={(e) => {
                            var title = BsyUtils._getSeachUserDeptList(e, null, { appId: appId || window.FX.STATIC.APPID, entryId: entryId || window.FX.STATIC.ENTRYID })
                            if (!title) {
                                return <span
                                    style={{
                                        overflow: 'unset',
                                        textOverflow: 'unset',
                                        whiteSpace: 'nowrap'

                                    }}
                                    title={e.nickname + ' ' + title} >
                                    {e.nickname}</span>
                            }
                            return <>
                                <span
                                    style={{
                                        overflow: 'unset',
                                        textOverflow: 'unset',
                                        whiteSpace: 'nowrap'

                                    }}
                                    title={e.nickname + ' ' + title} >
                                    {e.nickname}</span>
                                <span
                                    style={{
                                        overflow: 'unset',
                                        textOverflow: 'unset',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px',
                                        color: '#4D609F'

                                    }}
                                    title={e.nickname + ' ' + title} >
                                    {title}</span>
                            </>
                        }}
                        onAfterAsync={(e1) => {

                            if (e.options.type === "flowcreator_filter") {
                                if (e.method === BsyConfig().CONST.FILTER_METHOD.NIN)
                                    return e1;
                                return [{
                                    nickname: React.language("widget.user.anonymous"),
                                    _id: "anonymous",
                                }, ...e1]
                            }

                            return e1;


                        }}
                        onStopEdit={e1 => {
                            e.value = e.getValue()
                            BsyUtils.applyFunc(e, i.onStopEdit, [{
                                value: e.getValue(),
                                valueMode: e.valueMode,
                                method: e.method,
                            }, i], !1)
                        }}
                        async={c}
                    />
                }
            default:

        }



    }
    render() {
        return (<>
            {
                this.createTitleBar()
            }
            <div className='bsy-dash-cont' >
                {
                    this.renderCont()
                }
            </div>
        </>)
    }

}

